export default __webpack_public_path__ + "static/media/icon_filter.be6ab603.svg";